module.exports = __webpack_public_path__ + "img/387.e9b02e69.jpg";